import {Injectable, signal} from '@angular/core';
import {BaseStore} from '@infrastructure/store';

@Injectable({providedIn: 'root'})
export class BalanceStore extends BaseStore {
  readonly #balance = signal(0);
  readonly #isFirstExternalBalance = signal(false);

  readonly balance = this.#balance.asReadonly();
  readonly isFirstExternalBalance = this.#isFirstExternalBalance.asReadonly();

  setBalance(balance: number) {
    this.#balance.set(balance);
  }

  setIsFirstExternalBalance(isFirst: boolean) {
    this.#isFirstExternalBalance.set(isFirst);
  }
}
